import { Download, Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { useDownloadFile } from '@/lib/download-document-file';
import type { ProductionDeclarationCommodityOriginDocument } from '@/types/core/purchase-order/production-declaration-commodity-origin-document';

type ProductionDeclarationMaterialAdditionalFilesDownloadButtonProps = {
  document: ProductionDeclarationCommodityOriginDocument;
};

export function ProductionDeclarationMaterialAdditionalFilesDownloadButton({
  document,
}: ProductionDeclarationMaterialAdditionalFilesDownloadButtonProps) {
  const { t } = useTranslation('productionDeclaration', {
    useSuspense: false,
  });
  const { t: tCommon } = useTranslation('common', {
    useSuspense: false,
  });
  const { handleDownload, isPending } = useDownloadFile({
    clientUrl: document.clientUrl,
    fileName: document.name,
    onError: () => {
      toast.error(tCommon('error'), {
        description: t(
          'materialCommodityOrigins.cards.additionalFiles.actions.downloadError',
        ),
      });
    },
  });

  return (
    <Button
      aria-label={t(
        'materialCommodityOrigins.cards.additionalFiles.actions.download',
      )}
      className='h-auto p-0 text-declaration-foreground shadow-none transition-colors hover:bg-transparent hover:text-declaration-foreground-muted dark:text-declaration-foreground dark:hover:bg-transparent dark:hover:text-declaration-foreground-muted'
      disabled={!document.clientUrl || isPending}
      onClick={handleDownload}
      type='button'
      variant='ghost'
    >
      {isPending ? (
        <Loader2 className='size-[1.2rem] animate-spin' strokeWidth={2.1} />
      ) : (
        <Download className='size-[1.2rem]' strokeWidth={2.1} />
      )}
    </Button>
  );
}
